import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { AlertMessageService, LoadingService, Page } from "@serpro/ngx-suite-rfb";
import { Fragmento } from "src/app/shared/model/fragmento.model";
import { Lud, TipoLud } from "src/app/shared/model/lud.model";
import { Recurso } from "src/app/shared/model/recurso.model";
import { RecursoService } from "src/app/shared/services/recurso.service";
import { BancoRecursos } from "src/app/shared/util/banco-recursos.util";

@Component({
    selector: 'app-painel3-resultado',
    templateUrl: './painel3-resultado.component.html',
    styleUrls: ['./painel3-resultado.component.css', '../../../../../src/app/shared/css/contraste.css']
})
export class Painel3ResultadoComponent implements OnChanges {
    @Input() recursos: Recurso[];
    @Input() bancoRecursos: BancoRecursos;
    @Input() tipoPesquisa: number;
    @Input() isGerirRecursos: boolean;
    @Output() selecionarRecurso = new EventEmitter<Recurso>();
    @Output() dispositivoSelecionado = new EventEmitter<Lud>();
    @Output() atualizarRecursos = new EventEmitter<Recurso[]>();
    
    filtroDispositivo = '';
    pageSize = 100;
    currentPage: Page = { first: 0, last: this.pageSize, number: 1 };
    filtroNomeLUD = '';
    recursosFiltrados: Recurso[] = [];

    constructor(
        private readonly loadingService: LoadingService,
        private readonly alertMessageService: AlertMessageService,
        private readonly recursoService: RecursoService
    ) {}
    
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['recursos']) {
            this.filtroNomeLUD = '';        
            this.filtrarLUD(this.currentPage.number);
        }
        if (changes['tipoPesquisa']) {
            const tipoPesquisaNovo = changes['tipoPesquisa'].currentValue;
            if (tipoPesquisaNovo === 3) {
                this.buscarRecursosConfeccionados();
            }
        }
    }

    clickSelecionarRecurso(r: Recurso) {
        this.selecionarRecurso.emit(r);
    }

    clickSelecionarDispositivo(recurso: Recurso, dispositivo: Fragmento) {
        const lud = new Lud();
        if (recurso.idAto) {
            lud.url = this.bancoRecursos.obterUrlNormasExterno(recurso.idAto);
        } else {
            lud.url = recurso.url;
        }
        lud.idAto = recurso.idAto;
        lud.fragmento = dispositivo.fragmento;
        lud.dispositivo = dispositivo.dispositivo;
        lud.tipo = recurso.idAto ? TipoLud.LUD_NORMAS : TipoLud.LUD_INTERNET;
        this.dispositivoSelecionado.emit(lud);
    }

    public filtrar(fragmentos: Fragmento[]): Fragmento[] {
        if (fragmentos && fragmentos.length > 0) {
            return fragmentos.filter(f => f.dispositivo.indexOf(this.filtroDispositivo) >= 0);
        }
        return [];
    }

    public filtrarLUD(pagina = 1): void {
        if (this.filtroNomeLUD) {
            this.recursosFiltrados = this.recursos.filter(r => r.identificador.toLowerCase().indexOf(this.filtroNomeLUD.toLowerCase()) >= 0);
        } else {
            this.recursosFiltrados = this.recursos;
        }
        this.currentPage = { first: 0, last: this.pageSize, number: pagina };
    }

    public excluirRecurso(recurso: Recurso) {
        this.alertMessageService.dismissAll();
        if (recurso.idRecurso) {
            this.loadingService.show();
            this.recursoService.deletarRecurso(recurso.idRecurso).subscribe({
                next: () => {            
                    this.recursos = this.recursos.filter(r => r.idRecurso !== recurso.idRecurso);
                    this.buscarRecursosConfeccionados();
                    this.alertMessageService.info('Item excluído do banco de LUDs.');
                    this.loadingService.hide();
                },
                error: (e) => {
                    this.loadingService.hide();
                    this.alertMessageService.error(e.error.message);
                } 
            });
        }
    }

    buscarRecursosConfeccionados() {
        this.loadingService.show();
        this.recursoService.listarRecursos().subscribe({
            next: (recursos: Recurso[]) => {    
                for (const r of recursos) {
                    this.bancoRecursos.ordenarFragmentosPorDispositivo(r);
                }       
                this.atualizarRecursos.emit(recursos); 
                this.loadingService.hide();
            },
            error: () => {
                this.loadingService.hide();
            }
        });
    }
}